<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2">Contents</h2>
<p class="toc" id="rpre"><a href="#/xhtml/Preface#pre"><i>Preface and Acknowledgments</i></a></p>
<p class="toc" id="rabb"><a href="#/xhtml/Abbreviation#abb"><i>A Note on Transliteration and Abbreviation</i></a></p>
<p class="toc-3" id="rintr"><a href="#/xhtml/Introduction#intr">Introduction: Ledi Sayadaw and the Gifts of the Buddha</a></p>
<p class="toc-1" id="rch01"><a href="#/xhtml/Chapter_1#ch01">1 The Best of Times and the Worst: Ledi Sayadaw’s Formative Period</a></p>
<p class="toc-1" id="rch02"><span href="#/xhtml/Chapter_2#ch02" title="Link target outside of Sample">2 The Great War of the Commentaries: Ledi Sayadaw’s Abhidhamma Controversy</span></p>
<p class="toc-1" id="rch03"><span href="#/xhtml/Chapter_3#ch03" title="Link target outside of Sample">3 “In the Hands of All the People”: Ledi Empowers the Laity</span></p>
<p class="toc-1" id="rch04"><span href="#/xhtml/Chapter_4#ch04" title="Link target outside of Sample">4 “In This Very Life”: Lay Study of the Abhidhamma</span></p>
<p class="toc-1" id="rch05"><span href="#/xhtml/Chapter_5#ch05" title="Link target outside of Sample">5 The Birth of Insight</span></p>
<p class="toc-3" id="rcon"><span href="#/xhtml/Conclusion#con" title="Link target outside of Sample">Conclusion: The Death of Ledi and the Life of Insight</span></p>
<p class="toc-2" id="rglo"><span href="#/xhtml/Glossary#glo" title="Link target outside of Sample"><i>Glossary</i></span></p>
<p class="toc" id="rnot"><span href="#/xhtml/Notes#not" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc" id="rbib"><span href="#/xhtml/Bibliography#bib" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc" id="rinde"><span href="#/xhtml/Index#inde" title="Link target outside of Sample"><i>Index</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?6c003bfe